import React from "react"
import "./PlanDetails.css"
import Checked from "../../assets/Checked.png"
import CheckedGrayScale from "../../assets/CheckedGrayScale.png"
import { ROUTES } from "../../common/utils"
import { Link } from "react-router-dom"

function PlanOption(props) {
  return (
    <div className="PlanOption">
      <div style={{ backgroundColor: props.bg }} className="planOptionBox">
        <p className="planName">{props.plan}</p>
        <p className={(props.comingSoon && "comingSoon") || "peso"}>
          <span className="rate">
            {(props.rate && `${String.fromCharCode(8369)} ${props.rate}`) ||
              "Coming Soon"}
          </span>
        </p>
        {props.rate && (
          <>
            <p className="monthly">per month</p>
            <p className="selectPlan">
              <Link
                to={{
                  pathname: ROUTES.SUBSCRIPTION_PAYMENT,
                  state: {
                    plan: props.plan,
                    rate: props.rate,
                    referrer: props.referrer,
                    user: props.user
                  }
                }}
              >
                Select Plan
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  )
}

function Details(props) {
  return (
    <div className="container">
      <table className="table">
        <thead>
          <tr className={props.dashboard && "plans"}>
            <td className="row-header" />
            <td>
              <PlanOption
                bg="#4d6f87"
                plan="Standard"
                rate="490"
                referrer={props.referrer}
                user={props.user}
              />
            </td>
            <td>
              <PlanOption bg="#f1bb2d" plan="Plus" comingSoon={true} />
            </td>
            <td>
              <PlanOption bg=" #8f4307" plan="Premium" comingSoon={true} />
            </td>
          </tr>
        </thead>
        <tbody>
          {props.dashboard && (
            <tr className="blank">
              <td />
              <td />
              <td />
              <td />
            </tr>
          )}
          <tr>
            <th className="row-header">Payments</th>
          </tr>
          <tr>
            <td className="row-header">Transaction Fee*</td>
            <td>0%</td>
            <td>0%</td>
            <td>0%</td>
          </tr>
          <tr>
            <td className="row-header">Invoice</td>
            <td>
              <img alt="Checked" src={Checked} />
            </td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
          </tr>
          <tr>
            <td className="row-header">Multiple Payment Channels</td>
            <td>
              <img alt="Checked" src={Checked} />
            </td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
          </tr>
          <tr>
            <th className="row-header">Sales Channels</th>
          </tr>
          <tr>
            <td className="row-header">eCommerce Chatbot</td>
            <td>-</td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
          </tr>
          <tr>
            <td className="row-header">eCommerce Website</td>
            <td>-</td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
          </tr>
          <tr>
            <td className="row-header">Point of Sales</td>
            <td>-</td>
            <td>-</td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
          </tr>
          <tr>
            <th className="row-header">Inventory</th>
          </tr>
          <tr>
            <td className="row-header">Number of Products</td>
            <td>300</td>
            <td>Unlimited</td>
            <td>Unlimited</td>
          </tr>
          <tr>
            <td className="row-header">File Storage</td>
            <td>10 GB</td>
            <td>Unlimited</td>
            <td>Unlimited</td>
          </tr>
          <tr>
            <th className="row-header">Customer Care</th>
          </tr>
          <tr>
            <td className="row-header">Customer Care Chatbot</td>
            <td>-</td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
          </tr>
          <tr>
            <th className="row-header">Others</th>
          </tr>
          <tr>
            <td className="row-header">Promotions</td>
            <td>-</td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
            <td>
              <img alt="Checked" src={CheckedGrayScale} />
            </td>
          </tr>
          <tr>
            <td className="row-header">Users</td>
            <td>1</td>
            <td>3</td>
            <td>10</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

class PlanDetails extends React.Component {
  render() {
    return (
      <div>
        <Details
          dashboard={this.props.dashboard}
          referrer={this.props.referrer}
          user={this.props.user}
        />
      </div>
    )
  }
}

export default PlanDetails
